import React from 'react';
import styled from 'styled-components';

import { AttrsHelper } from '../../../sb-helpers/attrs-helper';

type ElementType =
  'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'div' | 'span';

interface H3Props {
  as: string;
  children: React.ReactNode;
  dataTest: string;
}

export interface SmallHeaderProps {
  as?: ElementType;
  children?: React.ReactNode;
  className?: string;
  name?: string;
  maxLines?: number;
  /**
   * Breaks a word anywhere rather than only where it could. Without it a run with no space in it -
   * a url, a hash, a pasted token - is one unbreakable word: it cannot wrap, so it sets the width
   * of whatever holds it and spills out of it rather than filling the lines `maxLines` allows.
   *
   * Only read alongside `maxLines`, which is what draws the lines to be kept to.
   */
  maxLinesStrict?: boolean;
}

const H3 = ({ as, children, dataTest }: H3Props) =>
  React.createElement(as, { dataTest }, children);

const StyledH3 = styled(H3)``;

export const SmallHeader = ({
  as = 'h3',
  children,
  className = '',
  name,
  maxLines,
  maxLinesStrict = false,
}: SmallHeaderProps) => (
  <StyledH3
    as={as}
    className={AttrsHelper.formatClassname(
      // When bootstrap goes away, change this to small-header
      'h3-small-header',
      maxLines && `max-lines-${maxLinesStrict ? 'strict-' : ''}${maxLines}`,
      className
    )}
    data-test={name}
  >
    {children}
  </StyledH3>
);
